import { Typography } from '@mui/material'
import { Warning } from '@mui/icons-material'

import Modal from 'components/molecules/Modal/Modal'
import { LoadingButton } from 'components/mui'

import { ConfirmChangesModalProps } from '../../TrayVisualization.types'
import './CancelChangesModal.scss'

const CancelChangesModal = ({
  open,
  onClose,
  handleConfirm,
  handleSaveChangesCancellation,
  modalText,
}: ConfirmChangesModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="tray-visualization-cancel-changes_modal">
        <div className="header-box">
          <Warning />

          <Typography variant="body1" textTransform="none">
            {modalText ||
              "You haven't selected any hardware from this tray. Are you sure no hardware from this tray was used in the procedure?"}
          </Typography>
        </div>

        <div className="buttons-container">
          <LoadingButton
            variant="outlined"
            disabled={false}
            loading={false}
            mode="cancel"
            onClick={handleConfirm}
          >
            Leave Anyways
          </LoadingButton>
          <LoadingButton
            disabled={false}
            loading={false}
            variant="contained"
            onClick={handleSaveChangesCancellation}
          >
            Continue Editing
          </LoadingButton>
        </div>
      </div>
    </Modal>
  )
}

export default CancelChangesModal
